if(typeof window.vm === 'undefined') {var e = new Error("Cannot find module \"window.vm\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = window.vm;


//////////////////
// WEBPACK FOOTER
// external "window.vm"
// module id = aGyC
// module chunks = 39 41 42 43